// ============================================================================
// Costanti — dati reali "2 ore PAGHE FEBBRAIO 26.xlsx" — MATTONE ROSSO
// ============================================================================

export const CANTIERI = [
  "Sesto Imolese - Via Nilde Iotti",
  "Piazza Duomo 4 - Imola (AHRCOS)",
  "Via delle Tovaglie 7 - Bologna (AHRCOS)",
  "Via Nosadella 29-33 - Bologna (AHRCOS)",
  "Via Panerazzi 327 - Crevalcore (MEDIL)",
  "Via Gandolfi 21 - Cadriano",
  "Villa Aldini - Bologna (MEDIL)",
  "Fenoglio",
  "Via Del Pratello 60 - Bologna (RICAP)",
  "Via della Pietra 18 - Bologna (RICAP)",
  "Via Serenari 15 - Castel Maggiore (Renolab)",
  "Via Tintoretto 17 - Bologna (RICAP)",
  "Via Tofane - Tolmino 2 (AHRCOS)",
  "Via Jacopo da Porto 495 - Baggiovara (MEDIL)",
  "Via Giuriolo 6 - Bologna (MEDIL)",
  "Via Castelnuovo 1 - Sant'Agata",
];

// Lista dipendenti caricata da Supabase (app_settings → baseDipendenti)
// Non inserire mai dati personali nel codice sorgente

export const AVATAR_COLORS = [
  ["#3b82f6","#2563eb"],["#8b5cf6","#7c3aed"],["#06b6d4","#0891b2"],
  ["#10b981","#059669"],["#f59e0b","#d97706"],["#ef4444","#dc2626"],
  ["#ec4899","#db2777"],["#6366f1","#4f46e5"],["#14b8a6","#0d9488"],
  ["#f97316","#ea580c"],["#84cc16","#65a30d"],["#a855f7","#9333ea"],
  ["#0ea5e9","#0284c7"],["#f43f5e","#e11d48"],["#22d3ee","#06b6d4"],
  ["#fb923c","#f97316"],["#4ade80","#22c55e"],["#c084fc","#a855f7"],
  ["#38bdf8","#0ea5e9"],["#fbbf24","#f59e0b"],["#34d399","#10b981"],
  ["#f87171","#ef4444"],["#a78bfa","#8b5cf6"],["#2dd4bf","#14b8a6"],
  ["#facc15","#eab308"],["#60a5fa","#3b82f6"],["#e879f9","#d946ef"],
  ["#86efac","#4ade80"],["#fca5a5","#f87171"],["#93c5fd","#60a5fa"],
  ["#6ee7b7","#34d399"],["#fcd34d","#fbbf24"],["#c4b5fd","#a78bfa"],
];

// Colori status dalla legenda del file Excel (colori reali #RGB)
export const STATUS_COLORS = {
  F:   { bg: "#FF33CC", text: "#fff",  label: "Ferie" },
  M:   { bg: "#FF9999", text: "#333",  label: "Malattia" },
  PMN: { bg: "#A9D18E", text: "#333",  label: "Perm. Non Retribuito" },
  Pm:  { bg: "#00B050", text: "#fff",  label: "Permesso" },
  PG:  { bg: "#F4B084", text: "#333",  label: "Pioggia" },
  A:   { bg: "#B4C6E7", text: "#333",  label: "Aspettativa" },
  C:   { bg: "#FFF2CC", text: "#333",  label: "Congedo Parentale" },
  D:   { bg: "#FFFF00", text: "#333",  label: "Dimesso" },
  I:   { bg: "#A3DBFF", text: "#333",  label: "Infortunio" },
  FS:  { bg: "#F6C3FF", text: "#333",  label: "Festivo" },
};

export const ORE_OPTIONS = ["4", "5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "10"];
